import {h, Component, Element, Host, Prop, Method} from "@stencil/core";
import {ContentData} from "../../core/content/domain/ContentData";
import {ContentParser} from "../../core/content/ContentParser";
import {ContentBuilder} from "../../core/content/builder/ContentBuilder";
import {ContentTypeEnum} from "../../core/content/builder/domain/ContentTypeEnum";

@Component({
    tag: 'snt-data',
    shadow: false
})
export class DataComponent {

    public static readonly TAG_NAME = "snt-data";

    @Element() element!: HTMLElement;

    @Prop() type:string;
    @Prop() lazyLoad:boolean;
    @Prop() src?:string;
    @Prop() data?:string;

    private builder:ContentBuilder<Object>;

    @Method()
    async getData() {
        return this.builder.build();
    }

    componentWillLoad() {
        let url = (this.src? new URL(this.src) : null);
        this.builder = ContentParser.parse(new ContentData(ContentTypeEnum.findByValue(this.type), this.lazyLoad, url, this.data));
    }

    render() {
        return (
            <Host />
        );
    }
}